import axios from 'axios';
import { API_URL } from '../Constants';
import { useMutation, useQuery } from 'react-query';

const sendMail = (values) => {
  return axios.post(API_URL + `/api/Mail/send`, values, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
    },
  });
};

export const useSendMail = () => {
  return useMutation(sendMail);
};

//sync
const syncNow = (values) => {
  return axios.post(API_URL + `/api/Mail/sync-now`, values, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
    },
  });
};

export const useSync = () => {
  return useMutation(syncNow);
};
//mark as read
const markAsRead = (id) => {
  return axios.post(
    API_URL + `/api/Mail/messages/${id}/markread`,
    { isRead: true },
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
      },
    },
  );
};

export const useMarkAsRead = () => {
  return useMutation(markAsRead);
};

///get mails
const fetchMailInbox = async (data) => {
  let url = `${API_URL}/api/Mail/inbox`;
  const queryParams = [`page=1`];

  if (data?.search) queryParams.push(`SearchBy=${data.search}`);
  if (data?.sort) queryParams.push(`sort=${data.sort}`);
  if (data?.filter) queryParams.push(`filter=${data.filter}`);
  if (data?.pageSize) queryParams.push(`pageSize=${data.pageSize}`);
  if (data?.folder) queryParams.push(`folder=${data.folder}`);
  if (data?.selectedLink) queryParams.push(`LinkedUserId=${data.selectedLink}`);
  if (queryParams.length > 0) {
    url += `?${queryParams.join('&')}`;
  }

  return await axios.get(url, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
    },
  });
};
export const useFetchMailInbox = (params) => {
  return useQuery({
    queryKey: ['mailInbox', params],
    queryFn: () => fetchMailInbox(params),
  });
};

//mail by id
const fetchMailById = async (id) => {
  if (id) {
    return await axios.get(API_URL + `/api/Mail/messages/${id}`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
      },
    });
  }
};
export const useFetchMailById = (id) => {
  return useQuery({
    queryKey: ['mailById', id],
    queryFn: () => fetchMailById(id),
    enabled: !!id,
  });
};

//conversation by id
const fetchConversationById = async (id) => {
  if (id) {
    return await axios.get(API_URL + `/api/Mail/inbox/conversation/${id}`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
      },
    });
  }
};
export const useFetchConversationById = (id) => {
  return useQuery({
    queryKey: ['conversationById', id],
    queryFn: () => fetchConversationById(id),
    enabled: !!id,
  });
};

//reply
const reply = ({ id, values }) => {
  return axios.post(API_URL + `/api/Mail/messages/${id}/reply`, values, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
    },
  });
};

export const useReply = () => {
  return useMutation(reply);
};

//replyALL
const replyAll = ({ id, values }) => {
  return axios.post(API_URL + `/api/Mail/messages/${id}/reply-all`, values, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
    },
  });
};

export const useReplyAll = () => {
  return useMutation(replyAll);
};

//Forward
const forward = ({ id, values }) => {
  return axios.post(API_URL + `/api/Mail/messages/${id}/forward`, values, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
    },
  });
};

export const useForward = () => {
  return useMutation(forward);
};

//delete
const deleteMail = (id) => {
  return axios.delete(
    API_URL + `/api/Mail/messages/${id}`,
    {},
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
      },
    },
  );
};

export const useDeleteMail = () => {
  return useMutation(deleteMail);
};
